// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3116":"2d2acb26","3992":"eda47a45","4617":"91d6c351","8587":"d5137a10"}[chunkId] + ".chunk.css";
};